import { createRouter, createWebHistory } from 'vue-router'
import PublicStatementList from '../views/PublicStatementList'
import PublicStatement from '../views/PublicStatement'

const routes = [
    {
        path: '/candidate-statements',
        name: 'PublicStatements',
        component: PublicStatementList
    },
    {
        path: '/candidate-statements/public-statement/:contestId/:candidateId/:language',
        name: 'PublicStatement',
        component: PublicStatement
    }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router;